import React from 'react'
import {
  useCanvasZoom,
  useIsInvertedZoomDirection,
} from '../../../../../components/WebRendererCanvas/hooks'
import { Zoom } from '../../../../../components/Zoom'
import { useGridAndLayoutPropForZoomComponent } from '../../../FrameView/hooks'
import { MAX_ZOOM, MIN_ZOOM } from '../../../../../components/Zoom/constants'

export const FloatingZoom = () => {
  const [zoom, setZoom] = useCanvasZoom()
  const gridAndLayoutPropsForZoomComponent =
    useGridAndLayoutPropForZoomComponent()
  const preventiveGridAndLayout = gridAndLayoutPropsForZoomComponent
  const [isZoomInverted, setIsZoomInverted] = useIsInvertedZoomDirection()

  return (
    <Zoom
      zoom={zoom}
      setZoom={setZoom}
      minZoom={MIN_ZOOM}
      maxZoom={MAX_ZOOM}
      gridAndLayout={preventiveGridAndLayout}
      isZoomInverted={isZoomInverted}
      setIsZoomInverted={setIsZoomInverted}
      explicitControls
    />
  )
}
